import React from 'react';
import { motion } from 'framer-motion';

const BenefitsWholeYouSection = () => {
    const fadeUpVariant = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    return (
        <section className="w-full py-[40px] md:py-[100px] bg-white font-sora">
            <div className="max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px]">
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    variants={fadeUpVariant}
                    className="flex flex-col md:flex-row bg-white border border-[#01386A45] overflow-hidden group shadow-sm hover:shadow-md transition-shadow duration-300"
                >
                    <div className="w-full md:w-1/2 lg:max-w-[529px] overflow-hidden h-[240px] sm:h-[300px] md:h-auto min-h-[240px] sm:min-h-[300px] md:min-h-[350px]">
                        <img
                            src="/assets/benefits/img1.png"
                            alt="Abstract purple 3D sphere"
                            className="w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-105"
                        />
                    </div>

                    <div className="w-full md:w-1/2 p-[24px] sm:p-[30px] md:p-[60px] lg:p-[80px] flex flex-col justify-center">
                        <h2 className="text-[20px] lg:text-[30px] font-[600] text-[#01386A] tracking-tight mb-[12px] md:mb-[20px]">
                            Benefits for the whole you
                        </h2>
                        <p className="text-[#49577A] text-[14px] md:text-[16px] font-graphik font-[500] leading-[1.6] md:leading-[1.7] max-w-[520px]">
                            We believe great work starts with a healthy, balanced life. That’s why we offer benefits that support your well-being, help you grow professionally, and give you the flexibility to achieve what matters most to you.
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default BenefitsWholeYouSection;